import Api from '@/utils/api';

class SingleRouterLoader {
  constructor(uriCreator, callback) {
    this.uriCreator =
      typeof uriCreator === 'string' ? () => uriCreator : uriCreator;
    this.callback = callback;
  }

  load(next, id) {
    const uri = this.uriCreator(id);
    new Api(uri)
      .get()
      .then(response => {
        const body = response.body;
        next(vm => this.callback(vm, body));
      })
      .catch(() => {
        // TODO errror messages
        next(false);
      });
  }
}

class SingleRouterUpdater {
  constructor(uriCreator, callback) {
    this.uriCreator =
      typeof uriCreator === 'string' ? () => uriCreator : uriCreator;
    this.callback = callback;
  }

  load(owner, id, next) {
    const uri = this.uriCreator(id);
    new Api(uri)
      .get()
      .then(response => {
        const body = response.body;
        this.callback(owner, body);
        next();
      })
      .catch(() => {
        // TODO errror messages
        this.callback(false);
      });
  }
}

/**
 * Un utilitaire pour la configuration de l'entrée dans une router pour composant. Le consumer est une fonction qui accepte 2 parametres withId, withNew qui sont des fonctions acceptant :
  - une chaine de caractère ou une fonction acceptant un identifiant et retournant une chaine de caracètre correspondant à l'URL sur le back àà àcharger
  - une fonction de callback recevant le vm vue en second parametres. Voir DetailPersonnePhysique.vue pour l'utilisation
 */
export function routeEnter(consumer) {
  const routes = {
    idLoader: null,
    newLoader: null,
  };

  const withId = (uriCreator, callback) =>
    (routes.idLoader = new SingleRouterLoader(uriCreator, callback));
  const withNew = (uriCreator, callback) =>
    (routes.newLoader = new SingleRouterLoader(uriCreator, callback));
  consumer(withId, withNew);
  return (to, from, next) => {
    if (to.params.id) {
      routes.idLoader.load(next, to.params.id);
    } else {
      routes.newLoader.load(next);
    }
  };
}

/**
 * Un utilitaire pour la configuration de la mise à jour d'une route pour composant. Le consumer est une fonction qui accepte 2 parametres withId, withNew qui sont des fonctions acceptant :
  - une chaine de caractère ou une fonction acceptant un identifiant et retournant une chaine de caracètre correspondant à l'URL sur le back àà àcharger
  - une fonction de callback recevant le vm vue en second parametres. Voir DetailPersonnePhysique.vue pour l'utilisation
 */
export function routeUpdate(consumer) {
  const routes = {
    idLoader: null,
    newLoader: null,
  };

  const withId = (uriCreator, callback) =>
    (routes.idLoader = new SingleRouterUpdater(uriCreator, callback));
  const withNew = (uriCreator, callback) =>
    (routes.newLoader = new SingleRouterUpdater(uriCreator, callback));
  consumer(withId, withNew);

  const f = function(to, from, next) {
    if (to.params.id) {
      routes.idLoader.load(this, to.params.id, next);
    } else {
      routes.newLoader.load(this);
    }
  };
  return f;
}

/**
 * Un utilitaire pour indexer par id un tableau d'enumeration
 */
export function indexEnums(cible, valeurEnum) {
  if (Array.isArray(valeurEnum)) {
    valeurEnum.forEach(item => {
      indexEnums(cible, item);
    });
    return;
  }

  if (valeurEnum) {
    const id = valeurEnum.id;
    cible[id] = {
      id,
      libelle: valeurEnum.libelle,
    };
  }
}
